import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { useLang, localized } from "../i18n/LanguageContext";
import { SEO_PREFIX } from "../i18n/translations";
import useSEO from "../hooks/useSEO";
import api from "../lib/api";

const Destinations = () => {
  const { lang, tr, lp } = useLang();
  const [cities, setCities] = useState([]);
  useSEO({ title: `${tr.destPage.title} — MobiRider`, description: tr.destPage.subtitle, lang });
  useEffect(() => { api.get("/cities").then((r) => setCities(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 py-12 md:py-20">
      <h1 className="font-heading font-extrabold text-4xl md:text-5xl text-ink tracking-tight">{tr.destPage.title}</h1>
      <p className="text-xl text-ink-muted mt-4 max-w-2xl">{tr.destPage.subtitle}</p>
      <div className="grid gap-7 md:grid-cols-2 mt-12">
        {cities.map((c) => (
          <Link key={c.id} to={lp(`/${SEO_PREFIX[lang]}-${c.slug}`)} data-testid={`dest-card-${c.slug}`} className="group relative rounded-3xl overflow-hidden h-72 shadow-md">
            <img src={c.hero_image} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/80 to-transparent" />
            <div className="absolute bottom-0 p-7">
              <h3 className="font-heading font-extrabold text-3xl text-white">{c.name}</h3>
              <p className="text-white/90 text-base mt-1 max-w-md">{localized(c.intro, lang)}</p>
              <span className="text-white flex items-center gap-2 mt-3 font-semibold text-lg">{tr.cityPage.rentIn} {c.name} <ArrowRight className="w-5 h-5" /></span>
            </div>
          </Link>
        ))}
      </div>
      <p className="text-center text-lg text-ink-muted mt-12 flex items-center justify-center gap-2"><MapPin className="w-5 h-5 text-brand" /> {tr.destPage.comingSoon}</p>
    </div>
  );
};

export default Destinations;
